<template>
	<div class="MAM_brandRewardList">
		<div style="margin-bottom: 20px;">
			<el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
			<span class="el-breadcrumb__inner" style="margin-left:20px">终端类型名称: {{ brandName }}</span>
			<el-card class="box-card" shadow="hover">
				<el-form :model="detalis"  class="demo-form-inline" label-width="100px" label-position="left">
					<el-form-item label="扣款开始时间" style="margin-bottom: 20px;">
						<span>首笔交易(包含押金交易)隔</span>
						<el-input  v-model="detalis.delay_day" disabled style="width: 70px;margin: 0px 5px;" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
						<span>天以后开始扣费</span>
					</el-form-item>
					<el-form-item label="APP提示语">
						<el-input v-model="detalis.tips" disabled style="width: 500px;"></el-input>
					</el-form-item>
				</el-form>
				<el-form class="demo-form-inline">
					<el-form-item>
						<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
							@click="onSubmit">新增</el-button>
					</el-form-item>
				</el-form>
			</el-card>
		</div>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="rewardTable" size="mini" border style="width: 100%">
				<el-table-column header-align="center" align="center" min-width="120" prop="is_default" label="默认值">
					<template  slot-scope="scope">
						<el-radio :label="scope.row.id" v-model="radioId" @change.native="agreeChange(scope.row)">
							<span></span>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" min-width="120" prop="temp_id" label="模板ID">
				</el-table-column>
				<el-table-column header-align="center" align="center" min-width="120" prop="target_money"
					label="流量扣费（元）"></el-table-column>
				<el-table-column header-align="center" align="center" min-width="120" prop="reward_money" label="返现（元）">
				</el-table-column>
				<el-table-column header-align="center" align="center" min-width="120" prop="status" label="状态">
					<template  slot-scope="scope">
						<el-switch
						  v-model="scope.row.status"
						  active-text="显示"
						  inactive-text="隐藏"
						  @change="switchChange(scope.row)">
						</el-switch>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		
		
		<el-dialog title="新增信息" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
			<el-form :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline" label-width="110px"
				label-position="left">

				<el-form-item label="流量扣费(元)" prop="target_money" style="margin-bottom: 20px;">
					<el-input v-model="formInline.target_money" style="width: 200px;"
						oninput="value=value.replace(/[^\d]/g,'')"></el-input>
				</el-form-item>

				<el-form-item label="返现(元)" prop="reward_money" style="margin-bottom: 20px;">
					<el-input v-model="formInline.reward_money" style="width: 200px;"
						oninput="value=value.replace(/[^\d]/g,'')"></el-input>
				</el-form-item>
				<el-form-item label="是否显示" prop="status" style="margin-bottom: 20px;">
					<el-select v-model="formInline.status" placeholder="请选择是否显示" style="width: 200px;">
						<el-option label="显示" value="1"></el-option>
						<el-option label="隐藏" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否为默认信息" prop="is_default" style="margin-bottom: 20px;">
					<el-select v-model="formInline.is_default" placeholder="请选择是否为默认信息" style="width: 200px;">
						<el-option label="是" value="1"></el-option>
						<el-option label="否" value="0"></el-option>
					</el-select>
				</el-form-item>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="determine()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "MAM_brandRewardList",
		data() {
			return {
				radioId:null,
				switchVal:null,
				brandId: null,
				rewardTable: [],
				brandName: this.$route.query.brandName, //zlf修改
				dialogVisible: false,
				formInline: {
					flow_card_id: null,
          reward_money:0,
				},
				listOption: [],
				rules: {
					target_money: [{
						required: true,
						message: '请输入流量扣费',
						trigger: 'blur'
					}, ],
					reward_money: [{
						required: true,
						message: '请输入返现',
						trigger: 'blur'
					}, ],
					status: [{
						required: true,
						message: '请选择是否显示',
						trigger: 'change'
					}],
					is_default: [{
						required: true,
						message: '请选择是否为默认信息',
						trigger: 'change'
					}],
				},
				detalis:{},
			}
		},
		mounted() {
			this.brandId = this.$route.query.id;
			this.brandName = this.$route.query.brandName;
			this.rowId = this.$route.query.rowId;
			this.getData();
			this.card_yearListOption();
		},

		methods: {
			//单选默认
			agreeChange(row){
				this.$confirm('确定修改数据, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.$api.post("brand/brand_reward_flow_card_conf_edit", {
				  	id: row.id,
					status:row.status,
					is_default:1,
				  }, res => {
				  	if (res.code == 0) {
						this.getData();
						this.$message.success(res.msg);
				  	} else {
				  		this.$message.error(res.msg);
				  	}
				  })
				}).catch(() => {
					this.getData();
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			//显示隐藏
			switchChange(row){
				this.$confirm('确定修改数据, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.$api.post("brand/brand_reward_flow_card_conf_edit", {
				  	id: row.id,
					status:row.status?1:0,
					is_default:row.is_default,
				  }, res => {
				  	if (res.code == 0) {
						this.getData();
						this.$message.success(res.msg);
				  	} else {
				  		this.$message.error(res.msg);
				  	}
				  })
				}).catch(() => {
					this.getData();
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			//获取次年流量卡设置详情
			card_yearListOption() {
				this.$api.post("brand/brand_reward_flow_card_info", {
					id: this.rowId
				}, res => {
					if (res.code == 0) {
						this.detalis = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			},

			//关闭弹框
			handleClose() {
				this.dialogVisible = false;
				this.$refs['formInline'].resetFields();
			},
			//打开新增弹框
			onSubmit() {
				this.dialogVisible = true;
				this.formInline.flow_card_id = this.$route.query.rowId;
			},
			//确定新增
			determine() {
				this.$refs['formInline'].validate((valid) => {
					if (valid) {
						this.$api.post("brand/brand_reward_flow_card_conf_add", this.formInline, res => {
							if (res.code == 0) {
								this.dialogVisible = false;
								this.getData();
								this.$message.success(res.msg);
								this.$refs['formInline'].resetFields();
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						return false;
					}
				});
			},


			getData() { //初始化
				this.$api.post("brand/brand_reward_flow_card_conf_list", {
					flow_card_id: this.rowId
				}, res => {
					if (res.code == 0) {
						this.rewardTable = res.data.list;
						this.rewardTable.map(res=>{
							if(res.is_default == 1){
								this.radioId = res.id
							}
							if(res.status == 0){
								res.status = false
							}else{
								res.status = true
							}
						})
					} else {
						this.$message.error(res.msg);
					}
				})
			},
		}
	};
</script>

<style lang="scss" scope>
	.MAM_brandRewardList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>
